export default {
  color: {
    background: "white",
    textColor: "#09a903",
    textShadow: " 3px 2px black",
  },
  gameArea: {
    background: "rgba(0, 0, 0, 0.5)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  button: {
    textColor: "#000000",
    boxShadow:
      " 0px 4px 4px rgba(0, 0, 0, 0.25), inset 3px 4px 4px rgba(206, 244, 205, 0.5)",
    boxShadowActive: "inset 3px 4px 4px rgba(0, 0, 0, 0.5)",
  },
};
